export const ADMIN_CUSTOMER_LIST_REQUEST = "ADMIN_CUSTOMER_LIST_REQUEST";
export const ADMIN_CUSTOMER_LIST_SUCCESS = "ADMIN_CUSTOMER_LIST_SUCCESS";
export const ADMIN_CUSTOMER_LIST_FAIL = "ADMIN_CUSTOMER_LIST_FAIL";

export const GET_CUSTOMER_REQUEST = "GET_CUSTOMER_REQUEST";
export const GET_CUSTOMER_SUCCESS = "GET_CUSTOMER_SUCCESS";
export const GET_CUSTOMER_FAIL = "GET_CUSTOMER_FAIL";

export const CUSTOMER_SEARCH_REQUEST = "CUSTOMER_SEARCH_REQUEST";
export const CUSTOMER_SEARCH_SUCCESS = "CUSTOMER_SEARCH_SUCCESS";
export const CUSTOMER_SEARCH_FAIL = "CUSTOMER_SEARCH_FAIL";

export const DELETE_CUSTOMER_REQUEST = "DELETE_CUSTOMER_REQUEST";
export const DELETE_CUSTOMER_SUCCESS = "DELETE_CUSTOMER_SUCCESS";
export const DELETE_CUSTOMER_FAIL = "DELETE_CUSTOMER_FAIL";

export const UPDATE_CUSTOMER_REQUEST = "UPDATE_CUSTOMER_REQUEST";
export const UPDATE_CUSTOMER_SUCCESS = "UPDATE_CUSTOMER_SUCCESS";
export const UPDATE_CUSTOMER_FAIL = "UPDATE_CUSTOMER_FAIL";
